import { EDITING_DOCUMENT__FILE_LOAD_REQUEST } from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

type EditingDocumentIdState = string | null;

const initialState: EditingDocumentIdState = null;

export default function reducer(
  state: EditingDocumentIdState = initialState,
  action: EditingDocumentAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FILE_LOAD_REQUEST:
      return action.payload;
    default:
      return state;
  }
}
